import { mapActions, mapGetters, mapState } from 'vuex';
import StoreSearchResultsTabMap from '@maison/components/store/StoreSearchResultsTabMap.vue';
import StoreSearchResultsTabList from '@maison/components/store/StoreSearchResultsTabList.vue';
import CTA from '@maison/components/common/CTA.vue';

export default {
  components: {
    StoreSearchResultsTabList,
    StoreSearchResultsTabMap,
    CTA,
  },

  props: {
    resultText: {
      type: String,
      default: '',
    },
    noResultsText: {
      type: String,
      default: '',
    },
    center: {
      type: Object,
      default: () => ({}),
    },
    zoom: {
      type: Number,
      default: 5,
    },
    cta: {
      type: Object,
      default: () => ({}),
    },
    shouldLoadStoresOnBoundsChanged: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      showMap: false,
    };
  },

  computed: {
    ...mapGetters('storeSearch', ['hasResults', 'searchPerformed']),

    ...mapState('storeSearch', ['stores', 'isLoading', 'currentTab']),
  },

  mounted() {
    this.resultComponentIsPresent();
  },

  methods: {
    ...mapActions('storeSearch', ['resultComponentIsPresent', 'changeCurrentTab']),
  },
};
